const DASH = '\u2013'

export function normalizeDisplayName(value) {
    if (typeof value !== 'string') return ''

    return value
        .replace(/\s*\/+\s*/g, ` ${DASH} `) // Slash(es) → – mit Spaces
        .replace(/\s+/g, ' ')               // Mehrfach-Whitespace einebnen
        .trim()
}